import qs from 'qs'
import _ from 'lodash'
import { ACCESS_KEY, urlAPI } from '../../urls'

type AnyObj = Record<string, any>

const apiPost = async (bodyObject: AnyObj) => {
  const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''
  const res = await fetch(`${urlAPI}`, {
    method: 'POST',
    body: JSON.stringify(bodyObject),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    },
  })
  return await res.json()
}
const getId = (x: any): number | null => {
  const id = x?.id ?? x?.data?.id
  return Number.isFinite(Number(id)) ? Number(id) : null
}

export const hydrateUnitLandlords = async (unit: AnyObj): Promise<AnyObj> => {
  const landlords = unit?.Landlords ?? []
  if (!Array.isArray(landlords) || landlords.length === 0) return unit

  const landlordIds: number[] = _.uniq(
    landlords
      .map((l: any) => getId(l?.Landlord))
      .filter((id: any): id is number => id != null)
  )

  const representativeIds: number[] = _.uniq(
    landlords
      .flatMap((l: any) => l?.Representatives?.data ?? l?.Representatives ?? [])
      .map((r: any) => getId(r))
      .filter((id: any): id is number => id != null)
  )

  const allIds = _.uniq([...landlordIds, ...representativeIds])
  if (allIds.length === 0) return unit

  const query = {
    pagination: { page: 1, pageSize: 200 },
    populate: {
      ContactInfo: '*',
      Documents: { populate: { Type: '*' } },
    },
    filters: { id: { $in: allIds } },
  }

  const resp = await apiPost({
    method: 'GET',
    collection: 'landlords',
    query: qs.stringify(query, { encodeValuesOnly: true }),
  })

  const byId = new Map<number, any>(
    (resp?.response?.data ?? []).map((x: any) => [x.id, x])
  )

  const hydrated = landlords.map((l: any) => {
    const lid = getId(l?.Landlord)

    const repsRaw = l?.Representatives?.data ?? l?.Representatives ?? []
    const reps = repsRaw.map((r: any) => byId.get(getId(r) ?? -1) ?? r)

    return {
      ...l,
      Landlord: lid != null ? (byId.get(lid) ?? l.Landlord) : l.Landlord,
      Representatives: reps,
    }
  })

  return { ...unit, Landlords: hydrated }
}

export const fetchLandlordsByIds = (ids: number[]) => async () => {
  const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''

  const query = {
    pagination: { page: 1, pageSize: 200 },
    populate: {
      ContactInfo: '*',
      Documents: { populate: { Type: '*' } },
    },
    filters: { id: { $in: ids } },
  }

  const bodyObject = {
    method: 'GET',
    collection: 'landlords',
    query: qs.stringify(query, { encodeValuesOnly: true }),
  }

  const res = await fetch(`${urlAPI}`, {
    method: 'POST',
    body: JSON.stringify(bodyObject),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    },
  })

  const json = await res.json()
  return json?.response?.data ?? []
}
